import {atom, useAtom} from 'jotai'

import {VIP} from '../domain'

export const VIPDetailAtom = atom<VIP | null>(null)
export const vipSelectedCampaignAtom = atom<string>('')
